import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { map, Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { TermsService } from '../../terms/terms.service';
import { UserRole } from '../enums/user-role.enum';
import { ImpersonateService } from '../impersonate/impersonate.service';
import { UserInterface } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class RegularUserGuard {
  private authService = inject(AuthService);
  private termsService = inject(TermsService);
  private impersonationService = inject(ImpersonateService);
  private router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const user: UserInterface = this.authService.getUser();

    return of(user).pipe(
      switchMap((user) => (user && !this.impersonationService.impersonated() ? of(user).pipe(this.termsService.getAgreement()) : of(true))),
      map((canContinue) => {
        if (!canContinue) {
          this.authService.logout();
          return false;
        }

        if (user && user.role?.name !== UserRole.ROLE_ADMIN && !user.isProfileComplete && state.url !== '/user/profile') {
          this.router.navigateByUrl('/user/profile');
          return false;
        }

        return true;
      }),
    );
  }
}
